import { render, staticRenderFns } from "./EmailFontSettings.vue?vue&type=template&id=9911e6e6&scoped=true"
import script from "./EmailFontSettings.vue?vue&type=script&lang=js"
export * from "./EmailFontSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9911e6e6",
  null
  
)

export default component.exports